import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from "react-redux";
import moment from 'moment';

import MindsetsJsSDK, {LoadingAction, ErrorMessageAction} from "../../../index";
import {getContentStreamEntity, plainTextToImmersiveReader} from '../../../utils/immersiveReader';

import './open_reader_switch.scss';

// import * as ImmersiveReader from '@microsoft/immersive-reader-sdk'

function OpenReaderSwitch(
    {
        challenge_version,
        stream_entity,
        from,
        content,
        tiny = false,
        analytic
    }
) {
    const dispatch = useDispatch();
    const [token, setToken] = useState(null);
    const [icon, setIcon] = useState(2);

    function getMSCSToken() {
        return new Promise((resolve, reject) => {
            if (token && moment(token.expires_on * 1000).isAfter(moment())) {
                resolve(token)
            } else {
                reject('MSCS token missing.')
            }
        }).catch(() => {
            dispatch(LoadingAction(true));
            return MindsetsJsSDK().API.get('cstoken').then((response) => {
                dispatch(LoadingAction(false));
                setToken(response.token);

                return response.token
            })
        }).catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error, false));

            throw error;
        })
    }

    function getContent() {
        if (content) {
            return plainTextToImmersiveReader(challenge_version, content)
        } else if (stream_entity) {
            return getContentStreamEntity(challenge_version, stream_entity)
        } else {
            return undefined
        }
    }

    function onPreferencesChangedCallback(string) {
        let object = JSON.parse(string);
        object.translationState.translationLanguage = JSON.parse(decodeURIComponent(object.translationState.translationLanguage)).text;
        let data = Object.assign({}, object.displayOptionsState, object.readAloudState, object.translationState);
        if (analytic) {
            analytic.log('immersiveReaderChanged', data);
        }
    }

    function onExitCallback() {
        if (analytic) {
            analytic.log('immersiveReaderClosed', challenge_version, stream_entity, from);
        }
    }

    function openOpenReader(token) {
        return ImmersiveReader.launchAsync(
            token.access_token,
            'mindsets-immersive-reader',
            getContent(),
            {
                onPreferencesChanged: onPreferencesChangedCallback,
                onExit: onExitCallback
            }
        ).catch(() => dispatch(ErrorMessageAction('Open Reader service in not available at the moment. Please reload the page and try again or try it later.', true)));
    }

    function onClick() {
        getMSCSToken().then(openOpenReader)
        if (analytic) {
            analytic.log('immersiveReaderOpened', challenge_version, stream_entity, from);
        }
    }

    function renderButton() {
        if (tiny) {
            return (
                <div className="open-reader-tiny">
                    <button className="open-reader-button" onClick={onClick}>
                        <img src={`${process.env.PUBLIC_S3_ASSETS_URL}/application/icon_immersive_reader_1.svg`}
                             alt={`Open Reader`}/>
                    </button>
                </div>
            );
        } else {
            return (
                <div className="open-reader-normal" onMouseOver={() => setIcon(1)}
                     onMouseOut={() => setIcon(2)}>
                    <button className="open-reader-button" onClick={onClick}>
                        <img
                            src={`${process.env.PUBLIC_S3_ASSETS_URL}/application/icon_immersive_reader_${icon}.svg`}
                            alt={`Open Reader`}/>
                        <div className="hide-on-small-only">
                            {`Open Reader`}
                        </div>
                    </button>
                </div>
            );
        }
    }

    return (
        <div className="open-reader">
            {renderButton()}
        </div>
    );
}

OpenReaderSwitch.propTypes = {
    challenge_version: PropTypes.object.isRequired,
    stream_entity: PropTypes.object,
    from: PropTypes.string,
    content: PropTypes.string,
    tiny: PropTypes.bool,
    analytic: PropTypes.shape({
        log: PropTypes.func.isRequired
    })
}

export default OpenReaderSwitch
